/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstitutionGridDto
 */
export interface InstitutionGridDto {
    /**
     * 
     * @type {number}
     * @memberof InstitutionGridDto
     */
    idinstitution?: number;
    /**
     * 
     * @type {string}
     * @memberof InstitutionGridDto
     */
    denomination?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionGridDto
     */
    localite?: string | null;
}

/**
 * Check if a given object implements the InstitutionGridDto interface.
 */
export function instanceOfInstitutionGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstitutionGridDtoFromJSON(json: any): InstitutionGridDto {
    return InstitutionGridDtoFromJSONTyped(json, false);
}

export function InstitutionGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinstitution': !exists(json, 'idinstitution') ? undefined : json['idinstitution'],
        'denomination': !exists(json, 'denomination') ? undefined : json['denomination'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
    };
}

export function InstitutionGridDtoToJSON(value?: InstitutionGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinstitution': value.idinstitution,
        'denomination': value.denomination,
        'localite': value.localite,
    };
}

